var map = {
	"./Cairo-Black.ttf": 178,
	"./Cairo-Bold.ttf": 179,
	"./Cairo-ExtraLight.ttf": 180,
	"./Cairo-Light.ttf": 181,
	"./Cairo-Regular.ttf": 182,
	"./Cairo-SemiBold.ttf": 183,
	"./Poppins-Black.ttf": 184,
	"./Poppins-Bold.ttf": 185,
	"./Poppins-ExtraBold.ttf": 186,
	"./Poppins-ExtraLight.ttf": 187,
	"./Poppins-Light.ttf": 188,
	"./Poppins-Medium.ttf": 189,
	"./Poppins-Regular.ttf": 190,
	"./Poppins-SemiBold.ttf": 191,
	"./Poppins-Thin.ttf": 192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;